import { EnvironmentProviders, inject, provideAppInitializer } from '@angular/core';

import { TranslocoService } from '@jsverse/transloco';
import { firstValueFrom } from 'rxjs';

import { LanguageService } from './language.service';
import { LANGUAGES } from './token/language.token';

export const provideLanguage = (): EnvironmentProviders =>
  provideAppInitializer(() => {
    const transloco = inject(TranslocoService);
    const languageService = inject(LanguageService);
    const availableLangs = inject(LANGUAGES);

    languageService.setLanguages(availableLangs);
    const lang = languageService.getLanguage();
    transloco.setActiveLang(lang);
    return firstValueFrom(transloco.load(lang));
  });
